import {
  dateRangeFiltersFields,
  isDateRangeFilterApplied,
} from 'app/dashboard/team_activity/ActivityFilters/DateRangeFilter'
import {
  isManagerFilterApplied,
  ManagerAppliedFilterRenderer,
  ManagerFilterBody,
  managerFilterDataExtractor,
} from 'app/dashboard/team_activity/ActivityFilters/ManagerFilter'
import {
  isPodsApplied,
  podFilterDataExtractor,
  PodsAppliedFilterRenderer,
  PodsFilterBody,
} from 'app/features/teams/messages/table-filters/PodsFilter'
import { utcFormatTimeStamp } from 'app/sm/helpers'

export const filtersIds = {
  dateRange: 'dateRange',
  manager: 'manager',
  dateFilterBy: 'dateFilterBy',
  teams: 'teams',
  pods: 'pods',
}

export const LEASED_DATE_FILTER_KEY = 'leased'
export const LISTED_DATE_FILTER_KEY = 'listed'

export const filtersInitialState = {
  filters: {
    [filtersIds.dateRange]: {
      [dateRangeFiltersFields.start]: null,
      [dateRangeFiltersFields.end]: null,
    },
    [filtersIds.manager]: [],
    [filtersIds.dateFilterBy]: LISTED_DATE_FILTER_KEY,
    [filtersIds.teams]: [],
    [filtersIds.pods]: {},
  },
}

const filtersAppliedChecker = {
  [filtersIds.dateRange]: isDateRangeFilterApplied,
  [filtersIds.manager]: isManagerFilterApplied,
  [filtersIds.pods]: isPodsApplied,
}

export const hasAppliedFilters = (filtersState) => {
  if (!filtersState) return false
  return Object.values(filtersIds).some((filterId) => {
    const filterValue = filtersState.filters[filterId]
    const filterAppliedChecker = filtersAppliedChecker[filterId]
    return filterAppliedChecker?.(filterValue)
  })
}

export const getFilters = (filtersState) => {
  const range = filtersState.filters[filtersIds.dateRange]?.dateRange
  const dateFilterBy = filtersState.filters[filtersIds.dateFilterBy]
  const managers = managerFilterDataExtractor(
    filtersState.filters[filtersIds.manager],
  ).managers
  const teams = filtersState.filters[filtersIds.teams]?.teams
  const pods = podFilterDataExtractor(
    filtersState.filters[filtersIds.pods],
  ).pods

  return {
    range,
    managers,
    teams,
    dateFilterBy,
    pods,
  }
}

const getRenderedFiltersConfig = (filterId, filtersValues, updateFilterFn) => {
  const filterValues = filtersValues[filterId]
  return {
    filterValues,
    isApplied: filtersAppliedChecker[filterId](filterValues),
    setFilterValues: (values) => updateFilterFn(filterId, values),
  }
}

export const buildRenderedFilterConfig = (
  filtersValues,
  updateFilterFn,
  includeManagersFilter,
  includePodsFilter,
) => {
  return {
    [filtersIds.dateRange]: {
      filterId: filtersIds.dateRange,
      startFieldName: dateRangeFiltersFields.start,
      endFieldName: dateRangeFiltersFields.end,
      format: utcFormatTimeStamp,
      ...getRenderedFiltersConfig(
        filtersIds.dateRange,
        filtersValues,
        updateFilterFn,
      ),
    },
    ...(includeManagersFilter && {
      [filtersIds.manager]: {
        AppliedFilterRenderer: ManagerAppliedFilterRenderer,
        FilterBody: ManagerFilterBody,
        filterTriggerPlaceholder: 'User',
        appliedFilterTitle: 'User',
        ...getRenderedFiltersConfig(
          filtersIds.manager,
          filtersValues,
          updateFilterFn,
        ),
      },
    }),
    ...(includePodsFilter && {
      [filtersIds.pods]: {
        AppliedFilterRenderer: PodsAppliedFilterRenderer,
        FilterBody: PodsFilterBody,
        filterTriggerPlaceholder: 'Pod',
        appliedFilterTitle: 'Pod',
        ...getRenderedFiltersConfig(
          filtersIds.pods,
          filtersValues,
          updateFilterFn,
        ),
      },
    }),
  }
}
